exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blog-comments[data-v-1d4b3d85]{margin-top:1.5rem;border-top:1px solid #f2f2f2;padding-top:1.5rem}.blog-comments .title[data-v-1d4b3d85]{margin-bottom:1rem}.blog-comments .comment-list[data-v-1d4b3d85]{margin-top:1.5rem;border-top:1px solid #f2f2f2;padding-top:.5rem}", ""]);

// exports
